import {
  VoiceIcon
} from "./chunk-EIKKTYAW.mjs";
export {
  VoiceIcon
};
